var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterListIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.5V8.5H21V6.5H3ZM10 18.5H14V16.5H10V18.5ZM18 13.5H6V11.5H18V13.5Z",
    fill: "#4F4F4F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterListIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter_list_icon.8a379fb995d4fc2156abc88eee0f5759.svg";